export const getBrowserInfo = () => {
  const {
    availHeight,
    availWidth,
    colorDepth,
    height,
    orientation: { angle, type } = {},
    pixelDepth,
    width,
  } = window.screen

  const {
    location: { protocol, hostname, pathname, search, hash },
    referrer,
  } = document

  const browser = {
    location: {
      hash,
      hostname,
      pathname,
      protocol,
      search,
    },
    referrer,
    screen: {
      availHeight,
      availWidth,
      colorDepth,
      height,
      orientation: { angle, type },
      pixelDepth,
      width,
    },
  }

  return browser
}
